/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const SPINNER_VIEWBOX = 16;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Spinner (16×16). Track and arcs use `trackFill` / `arcFill` / `arc2Fill` (themeable CSS vars by default).
 * Pass `aria-label` when the spinner conveys meaning without adjacent text.
 */
const SpinnerIcon = ({
  className = '',
  size = 16,
  trackFill = 'var(--ds-button-loader-track-fill, rgba(216, 77, 255, 0.1))',
  arcFill = 'var(--ds-button-loader-arc, var(--ds-theme-action-primary))',
  arc2Fill = 'var(--ds-button-loader-arc, var(--ds-theme-action-primary))',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${SPINNER_VIEWBOX} ${SPINNER_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM2.75 8C2.75 10.8995 5.1005 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.1005 10.8995 2.75 8 2.75C5.1005 2.75 2.75 5.1005 2.75 8Z"
      fill={trackFill}
    />
    <path
      d="M15 8C15 9.10467 14.7386 10.1937 14.2371 11.1779C13.7356 12.1622 13.0082 13.0138 12.1145 13.6631C11.2208 14.3124 10.1861 14.741 9.09507 14.9138C8.004 15.0866 6.88752 14.9988 5.83691 14.6574L6.37769 12.993C7.16565 13.2491 8.00301 13.315 8.82131 13.1854C9.63962 13.0558 10.4156 12.7343 11.0859 12.2473C11.7562 11.7604 12.3017 11.1217 12.6778 10.3835C13.054 9.64525 13.25 8.8285 13.25 8H15Z"
      fill={arcFill}
    />
    <path
      d="M0.999966 8C0.999966 6.89533 1.26141 5.80634 1.76292 4.82207C2.26443 3.8378 2.99177 2.98619 3.88547 2.33688C4.77917 1.68757 5.81385 1.25899 6.90493 1.08618C7.996 0.913372 9.11248 1.00124 10.1631 1.3426L9.62231 3.00695C8.83435 2.75093 7.99699 2.68503 7.17869 2.81464C6.36038 2.94424 5.58437 3.26568 4.91409 3.75266C4.24382 4.23964 3.69832 4.87835 3.32218 5.61655C2.94605 6.35475 2.74997 7.1715 2.74997 8H0.999966Z"
      fill={arc2Fill}
    />
  </svg>
);

SpinnerIcon.propTypes = {
  ...iconPropTypes,
  /** Outer ring fill (usually a faint surface). */
  trackFill: PropTypes.string,
  /** Primary arc fill (usually brand). */
  arcFill: PropTypes.string,
  /** Secondary arc fill (defaults to same as `arcFill`). */
  arc2Fill: PropTypes.string,
};

export { SpinnerIcon };
export default SpinnerIcon;
